
<template>
    <div class="about-section">
        <article class="maj-section box badges">
            <header>
            <h3><span> {{ displayText }} </span></h3>
            </header>
            <div>
            <span class="badges" v-for="badge in badges" :key="badge.name"><img :src="proxyBadge(badge)"></span>
            </div>
        </article>
    </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'
import i18n from '@/i18n'

export default {
  props: ['badges', 'user'],

  computed: {
    hasBadges: function () {
      return this.badges.length > 0
    },
    name: function () {
      if (!this.user.fullName) {
        return this.user.userName
      }
      return this.user.fullName
    },
    displayText: function () {
      if (this.$i18n.locale === 'fr') {
        return i18n.t('sectionProfile.badges') + this.name
      } else {
        return this.name + '\'s ' + i18n.t('sectionProfile.badges')
      }
    }
  },
  methods: {
    proxyBadge: function (badge) {
      return imageProxy.proxy(badge.image, { width: 100, quality: 80 })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
  .about-section{
    padding: 1rem 0;
    h3{
      font-weight:600;
    }
  }
  .badge {
    padding-left: 1rem;
    @include mobile {
      padding-left: 0.25rem;
    }
  }
  img {
    max-height: 150px;
    max-width: 150px;
  }
</style>
